export class Provider  {
  id?:number;
  rut:string;
  name:string;
  email:string;
  address:string;
  contact:string;
  phone: string;
  country:number

  constructor(id , rut, name, email, address, contact, phone, country ){
    this.id = id;
    this.rut = rut;
    this.name = name;
    this.email = email;
    this.address = address;
    this.contact = contact;
    this.phone = phone;
    this.country = country;
  }


  public getJson(){

    return `{
      "data":{
        "type": "companies",
        "id": "${this.id}",
        "attributes": {
          "rut": "${this.rut}",
          "name": "${this.name}",
          "email": "${this.email}",
          "address": "${this.address.replace(/\r?\n|\r/g, " ")}",
          "contact": "${this.contact}",
          "phone": "${this.phone}",
          "country_id": "${this.country}"
        }
      }
    }`;

  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Provider.ts